import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {FlightModeGameAssets} from "../../FlightModeGameAssets";
import {FlightMode} from "../../FlightMode";
import {gsap} from "gsap";

export class FlightModeBackgroundElements extends PIXI.Container implements StageLayer {

    private baseGame:PIXI.Sprite;
    private freespins:PIXI.Sprite;
    baseGameCard:PIXI.Sprite;
    freespinsCard:PIXI.Sprite;
    noWinCard:PIXI.Sprite;

    constructor() {
        super();
        this.name = "FlightModeBackgroundElements";

        this.baseGame = new PIXI.Sprite(FlightMode.assetLoader.getTextures(FlightModeGameAssets.BASE_GAME_BACKGROUND)[0]);
        this.baseGame.position.set(360,360);
        this.baseGame.anchor.set(0.5,0.5);

        this.freespins = new PIXI.Sprite(FlightMode.assetLoader.getTextures(FlightModeGameAssets.FREESPINS_BACKGROUND)[0]);
        this.freespins.position.set(360,360);
        this.freespins.anchor.set(0.5,0.5);
        this.freespins.alpha = 0;

        this.baseGameCard = new PIXI.Sprite(FlightMode.assetLoader.getTextures("BG_Postcards/Postcard_A")[0]);
        this.baseGameCard.position.set(360,312);
        this.baseGameCard.anchor.set(0.5,0.5);

        this.freespinsCard = new PIXI.Sprite(FlightMode.assetLoader.getTextures("BG_Postcards/Postcard_B")[0]);
        this.freespinsCard.position.set(360,312);
        this.freespinsCard.anchor.set(0.5,0.5);
        this.freespinsCard.alpha = 0;

        this.noWinCard = new PIXI.Sprite(FlightMode.assetLoader.getTextures("BG_Postcards/Postcard_C")[0]);
        this.noWinCard.position.set(360,312);
        this.noWinCard.anchor.set(0.5,0.5);
        this.noWinCard.alpha = 0;

        this.addChild(this.baseGame);
        this.addChild(this.freespins);
        this.addChild(this.baseGameCard);
        this.addChild(this.freespinsCard);
        this.addChild(this.noWinCard);
    }

    public onOrientationChanged() {}

    public onResize() {}

    public setToFreespins() {
        this.baseGame.alpha = 0;
        this.freespins.alpha = 1;
        this.baseGameCard.alpha = 0;
        this.freespinsCard.alpha = 1;
    }

    public setToBaseGame() {
        this.baseGame.alpha = 1;
        this.freespins.alpha = 0;
        this.baseGameCard.alpha = 1;
        this.freespinsCard.alpha = 0;
    }

    public fadeInNoWin() {
        gsap.timeline()
            .add(gsap.to(this.noWinCard, {alpha:1, duration:0.1}))
            .add(gsap.to(this.baseGameCard, {alpha:0, duration:0.1}), '<')
    }

    public fadeOutNoWin() {
        if (this.noWinCard.alpha == 0)
            return;
        gsap.timeline()
            .add(gsap.to(this.noWinCard, {alpha:0, duration:0.1}))
            .add(gsap.to(this.baseGameCard, {alpha:1, duration:0.1}), '<')
    }

    public restore(isBaseGame:boolean) {
       if (isBaseGame){
           this.setToBaseGame()
       } else {
           this.setToFreespins()
       }
    }

    shake(bigShake:boolean = false):gsap.core.Timeline {
        const shakeIntensity = bigShake ? "random(-25, 25, 1)" : "random(-5, 5, 1)"
        return gsap.timeline()
            .add(gsap.to(this, {x: shakeIntensity, y: shakeIntensity, duration: 0.03}))
            .add(gsap.to(this, {x: 0, y: 0, duration: 0.03}))
    }
}